// extracted by mini-css-extract-plugin
export default {"container":"styles_container__dKM23","logo":"styles_logo__h56J2","mdlogo":"styles_mdlogo__fNOO8"};